export const examStatusEnu = {
    locked: "locked",
    unlocked: "unlocked",
    started: "started",
    submitted: "submitted",
    viewResult: "viewResult",
    hideResult: "hideResult"
} as const

export const examStatusTextEnu = {
    hideResult: "Hide Result"
} as const

export const examResults = {
    passed: "passed",
    failed: "failed"
}

export const seriesStatus = {
    enrolled: "enrolled",
    active: "active",
    paused: "paused",
    expired: "expired",
    completed: "completed",
} as const


export const courseStatus = {
    enrolled: "enrolled",
    active: "active",
    completed: "completed",
} as const

export const examType = {
    exam: "exam",
    practice: "practice"
} as const